import api from "../common/api";

const getAll = () => api.get("universidade/integracao/logistica");

const get = (id) => api.get(`universidade/integracao/logistica/${id}`);

const create = () => api.post("universidade/integracao/logistica");

const update = (id, data) =>
  api.put(`universidade/integracao/logistica/${id}`, data);

const addVideo = (id, data) =>
  api.put(`universidade/integracao/logistica/${id}/video`, data);

const addArquivo = (id, data) =>
  api.put(`universidade/integracao/logistica/${id}/arquivo`, data);

const remove = (id) => api.delete(`universidade/integracao/logistica/${id}`);

const removeVideo = (id, idVideo) =>
  api.delete(`universidade/integracao/logistica/${id}/video/${idVideo}`);

const removeArquivo = (id, idArquivo) =>
  api.delete(`universidade/integracao/logistica/${id}/arquivo/${idArquivo}`);

const universidadeIntegracaoLogisticaService = {
  getAll,
  get,
  create,
  update,
  addVideo,
  addArquivo,
  remove,
  removeVideo,
  removeArquivo,
};

export default universidadeIntegracaoLogisticaService;
